import { useEffect, useState } from 'react';

interface ITimeLeft {
  fullMinutes: number;
  seconds: number;
}

const useCountdown = (futureDate: Date | string): ITimeLeft | undefined => {
  const calculateTimeLeft = (): ITimeLeft | undefined => {
    const differenceInSeconds = (new Date(futureDate).getTime() - new Date().getTime()) / 1000;
    if (differenceInSeconds > 0) {
      return {
        seconds: Math.floor((differenceInSeconds) % 60),
        fullMinutes: Math.floor((differenceInSeconds / 60) % 60) + 1,
      };
    }
    return undefined;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return timeLeft;
};

export default useCountdown;
